import { createAction, props } from "@ngrx/store";
import { ICompany, ICreateCompanyRequest, IUpdateCompanyRequest } from "src/app/company/models/company";

// Get Companies
export const getCompanies = createAction(
    '[Companies] Get Companies'
);

export const getCompaniesSuccess = createAction(
    '[Companies] Get Companies success', 
    props<{ companies: ICompany[] }>()
);

export const getCompaniesFailure = createAction(
    '[Companies] Get Companies failure',
    props<{error: string}>()
);

// Create Companies
export const createCompany = createAction(
    '[Companies] Create Company',
    props<{ company: ICreateCompanyRequest }>()
);

export const createCompanySuccess = createAction(
    '[Companies] Create Company success',
    props<{ company: ICompany }>()
);

export const createCompanyFailure = createAction(
    '[Companies] Create Company failure',
    props<{error: string}>()
);

// Update Companies 
export const updateCompany = createAction(
    '[Companies] Update Company',
    props<{ company: IUpdateCompanyRequest }>()
);

export const updateCompanySuccess = createAction(
    '[Companies] Update Company success',
    props<{ company: ICompany }>()
);

export const updateCompanyFailure = createAction(
    '[Companies] Update Company failure',
    props<{error: string}>()
);
// Delete Companies 
export const deleteCompany = createAction(
    '[Companies] Delete Company',
    props<{id: string}>()
);

export const deleteCompanySuccess = createAction(
    '[Companies] Delete Company success',
    props<{id: string}>()
);

export const deleteCompanyFailure = createAction(
    '[Companies] Delete Company failure',
    props<{error: string}>()
);